/* External */
import { all, put, take, takeLatest } from "redux-saga/effects";

/* Services */
import { backendService } from "../../../services";

/* Actions */
import {
  actionTypes,
  ACTION_TYPES_BASE_NAME,
  PULSE_STREAM_HEARTBEAT,
  fetchStreamHeartbeat,
  resetStreamHeartbeat
} from "./actions";

/* Others */
import { HEARTBEAT_ASSET_TYPES, HEARTBEAT_PULSE_TYPES, makeFetchSaga } from "../../../utils";

function* pulseStreamHeartbeat({ payload }) {
  yield put(fetchStreamHeartbeat(payload));

  if (payload.pulseAction !== HEARTBEAT_PULSE_TYPES.STOP) return;

  yield take(actionTypes.SUCCESS);
  yield put(resetStreamHeartbeat());
}

const sendPulseStreamHeartbeat = makeFetchSaga(ACTION_TYPES_BASE_NAME, {
  getFunc: ({ pulseAction }) => {
    switch (pulseAction) {
      case HEARTBEAT_PULSE_TYPES.SEND:
        return backendService.experience.setStreamConcurrency;
      case HEARTBEAT_PULSE_TYPES.STOP:
        return backendService.experience.stopStreamConcurrency;
      default:
        return;
    }
  },
  getParams: (payload, state) => {
    const { isLive, progress = 0, sessionId = "", streamedCount = 0 } = payload;
    const deviceId = state.user.deviceId;
    const content = isLive ? state.player.content?.data?.[0] || {} : state.player.content.data;
    const contentId = isLive ? content.stationID : content.id;
    const assetDuration = state.player.asset.data?.duration;
    const contentType = isLive ? HEARTBEAT_ASSET_TYPES.EPG : HEARTBEAT_ASSET_TYPES.VOD;

    return [
      contentId,
      {
        contentType,
        device: deviceId,
        duration: assetDuration,
        metadataId: content.id || "",
        progress,
        sessionId,
        streamed: streamedCount
      }
    ];
  }
});

export default function* () {
  yield all([takeLatest(PULSE_STREAM_HEARTBEAT, pulseStreamHeartbeat), sendPulseStreamHeartbeat]);
}
